import Image, { ImageProps } from 'next/image';
export default function OrgIcon(props: Omit<ImageProps, 'src'> & { size?: number }) {
  const { size, ...restProps } = props;
  return <Image src='/assets/icons/org.svg' width={size || 24} height={size || 24} {...restProps} />;
}
